import intl from 'react-intl-universal';
import { Row, Col, Tag } from 'antd';
import { default as Button } from '@/components/CssBtn';

import style from './index.less';
import Exhibition from '../Exhibition';

interface Props {
    goodsColumns?: any[];
    problemColumns?: any[];
    goodsTitle?: any[];
    repairGoodsTitle?: string;
    // informationBtnText?: any[];
    infoColumns?: any[];
    theSameColumns?: boolean;
    goodsList?: any[];
    // infoList?: any[];
    problemList?: any[];
    onClickModal?: (flag: boolean, commoditys: any) => void;
}

const AfterSaleGoods: React.FC<Props> = (props) => {
    const {
        goodsColumns = [],
        problemColumns = [],
        goodsTitle = [],
        repairGoodsTitle = '',
        // informationBtnText = [],
        // infoColumns = [],
        // theSameColumns = true,
        goodsList = [],
        // infoList = [],
        problemList = [],
        onClickModal,
    } = props;

    // const [tabKey, setTabKey] = useState<number>(0);

    // const changebBtn = (ind: number) => {
    //     setTabKey(ind);
    // };
    return (
        <div className={style.afterSaleContainer}>
            {goodsList?.map((item, index) => {
                return (
                    <div key={index}>
                        <Row
                            gutter={32}
                            className={style.goodsContainer}
                        >
                            {item?.map((itm: any, ind: number) => {
                                return (
                                    <Col
                                        className={style.afterSaleItem}
                                        key={ind}
                                        span={24 / item?.length}
                                    >
                                        {goodsTitle.length &&
                                            item?.length > 1 && (
                                                <p
                                                    className={
                                                        style.afterSaleTitle
                                                    }
                                                >
                                                    {goodsTitle[ind]}
                                                </p>
                                            )}
                                        {itm?.stockoutTag && (
                                            <Tag
                                                color="orange"
                                                className={style.tag}
                                            >
                                                {intl.get('缺货')}
                                            </Tag>
                                        )}
                                        {itm?.is_hidden && (
                                            <Tag
                                                color="orange"
                                                className={style.tag}
                                            >
                                                {intl.get('隐藏')}
                                            </Tag>
                                        )}
                                        <Exhibition
                                            config={{ col: 2 }}
                                            data={item[ind]}
                                            labelWidth={90}
                                            columns={goodsColumns}
                                        />

                                        {itm?.optionalTag && (
                                            <Button
                                                type="primary"
                                                size="small"
                                                className={style.stockoutBtn}
                                                onClick={() => {
                                                    onClickModal?.(
                                                        true,
                                                        item[0],
                                                    );
                                                }}
                                            >
                                                {intl.get('选择商品')}
                                            </Button>
                                        )}
                                    </Col>
                                );
                            })}
                        </Row>
                        {problemList[index]?.flaw_reason_list ? (
                            problemList[index]?.flaw_reason_list.map(
                                (problem: any, problemIndex: number) => {
                                    return (
                                        <div
                                            className={style.bottomAfterSale}
                                            key={problemIndex}
                                        >
                                            {repairGoodsTitle && (
                                                <p
                                                    className={
                                                        style.repairGoodsTitle
                                                    }
                                                >
                                                    {repairGoodsTitle}&nbsp;
                                                    {problemIndex + 1}
                                                </p>
                                            )}
                                            <Exhibition
                                                config={{ col: 3 }}
                                                data={{
                                                    ...problem,
                                                    original_product_info:
                                                        problemList[index]
                                                            ?.original_product_info,
                                                }}
                                                columns={problemColumns}
                                            />
                                        </div>
                                    );
                                },
                            )
                        ) : (
                            <div
                                key={index}
                                className={style.bottomAfterSale}
                            >
                                <Exhibition
                                    config={{ col: 3 }}
                                    data={problemList[index]}
                                    columns={problemColumns}
                                />
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default AfterSaleGoods;
